<template>
  <div id="container" class="white-dark">
    <div class="header-header">
      <div class="text-us-container">
        <!-- <img
          class="burger-menu-icon"
          loading="eager"
          alt=""
          src="../assets/burgermenu.svg"
          @click="toggleSidebar"
        /> -->
        <button
          class="semi-bold text-us-btn"
          type="button"
          aria-label="Text us"
          @click="textUsClicked"
        >
          <img class="text-us-btn__icon" src="../assets/chat_bubble_blue.svg" alt="" />
          Text Us
        </button>
      </div>
      <h3 class="large-bold" v-if="!isSmallResults">
        {{  units ? Object.keys(units).length + " Results" : "Welcome" }}
      </h3>
      <div v-if="!isSmallResults" id="x-container" @click="closeChatWindow">
        <div class="x-line r-right"></div>
        <div class="x-line r-left"></div>
      </div>
    </div>
    <div v-if="!units" class="logo-container" style="padding: 10px;">
      <img style="height: 100%;" :src="getLogoSrc()"/>
    </div>
    <p v-if="!units" class="large-reg">
      I can help find the right RV for you. Start by<br />telling me what
      you are looking for.
    </p>
    <UnitResults v-if="!isSmallResults && units" :units="units" :small="isSmallResults"></UnitResults>
    <SideBar v-if="sidebarOpen" :isOpen="sidebarOpen" @close="toggleSidebar" />
  </div>
  <!-- <img
    v-if="!isSmallResults && units"
    class="collapse-button-icon"
    loading="lazy"
    alt=""
    src="../assets/collapsebutton.svg"
    @click="toggleUnitResults"
  /> -->
</template>

<script setup>
import UnitResults from "./UnitResults.vue";
import SideBar from "./sidebar/SideBar.vue";
import { useSearchResultsStore } from "@/stores/useSearchResultsStore";
import { useWindowStateStore } from "@/stores/useWindowStateStore";
import { ref, onMounted, onUnmounted } from "vue";
import { storeToRefs } from "pinia";

const searchResultsStore = useSearchResultsStore();
const { searchResults: units } = storeToRefs(searchResultsStore);
const windowStateStore = useWindowStateStore();
const { toggleChatWindow } = windowStateStore;

const sidebarOpen = ref(false);
const isSmallResults = ref(false);

onMounted(() => {
  searchResultsStore.initialize();
});

onUnmounted(() => {
  searchResultsStore.dispose();
});

function getLogoSrc() {
  return process.env.VUE_APP_LOGO_IMG_SRC;
}

function toggleSidebar() {
  sidebarOpen.value = !sidebarOpen.value;
}

function textUsClicked() {
  console.log("textUsClicked");
  windowStateStore.showContactForm = true;
}

function closeChatWindow() {
  toggleChatWindow();
}
</script>

<style scoped>
#container {
  width: 100%;
  background-color: var(--black-default);
  padding-top: 10px;
  padding-bottom: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.collapse-button-icon {
  width: 34px;
  height: 34px;
  position: absolute;
  margin: 0 !important;
  top: 266px;
  left: 24px;
  border-radius: 0px 4.25px 4.25px 0px;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: contain;
  z-index: 2;
}

.header-header {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0px 15px;
  box-sizing: border-box;
  text-align: center;
  position: relative;
}

.header-header > h3 {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
  max-width: calc(100% - 140px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
}

.x-line {
  height: 20px;
  width: 2px;
  border-radius: 1px;
  background-color: var(--white-dark);
  position: absolute;
  top: 50%;
  left: 50%;
}

.r-right {
  transform: translate(-50%, -50%) rotate(45deg);
}

.r-left {
  transform: translate(-50%, -50%) rotate(-45deg);
}

#x-container {
  position: relative;
  width: 48px;
  height: 48px;
  flex: 0 0 20px;
  cursor: pointer;
}

.text-us-container {
  position: relative;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.text-us-btn {
  height: 34px;
  border-radius: 4px;
  border: 0.5px solid var(--primary-accent-base);
  background-color: var(--white-dark);
  color: var(--black-default);
  cursor: pointer;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  position: relative;
  z-index: 3;
  pointer-events: auto;
  font-size: 1rem;
}

.text-us-btn__icon {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  margin-right: 8px;
  display: block;
  object-fit: contain;
}

.text-us-btn:active {
  transform: translateY(0.5px);
}

.logo-container {
  height: 80px;
}

#logo {
  width: 100%;
  height: 100%;
  background-color: var(--white-dark);
  border-radius: 8px;
}

#container > p {
  margin: 0;
  margin-top: 17px;
  text-align: center;
}
</style>
